<template>
  <v-select
    :options="options"
    :multiple="true"
    :label="label"
    :reduce="reduce"
    :placeholder="placeholder"
    v-model="internalValue"
  />
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
  name: 'vSelectCoklu',
  components: { vSelect },
  props: {
    modelValue: {
      type: [Array, String],
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'ad'
    },
    reduce: {
      type: Function,
      default: option => option.id
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
};
</script> 